<template>
  <div :class="[customClass,  'input-group']">
    <div class="input-group-prepend">
      <span class="input-group-text">
        <i class="fa fa-search" aria-hidden="true"></i>
      </span>
    </div>
    <input
      class="form-control"
      type="search"
      placeholder
      aria-label="Search"
      v-model="searchTerm"
      @keyup.enter="search"
    >
  </div>
</template>

<script>
export default {
  data () {
    return {
      searchTerm: ''
    }
  },
  mounted () {

  },
  props: {
    customClass: {
      type: String,
      required: false
    }
  },
  methods: {
    search (event) {
      let term = { search: this.searchTerm }
      if (!this.isEmpty(term)) {
        this.$emit('searchterm', term)
      }
    },
    isEmpty (str) {
      return (!str || str.length === 0)
    }
  }
}

</script>
